<template>
  <TwoColumnQuizReviewLayout>
    <template #responses>
      <ResponseItem
        v-for="(option) in responses"
        :key="option.id"
        :option="option"
        :showCheckMarkIcon="true"
        :class="{
          'correct': option.correct,
          'incorrect': !option.correct,
        }"
      />
    </template>
    <template #answers>
      <ResponseItem
        v-for="(option) in answers"
        :key="option.id"
        :option="option"
        :showCheckMarkIcon="false"
      />
    </template>
  </TwoColumnQuizReviewLayout>
</template>

<script>
import TwoColumnQuizReviewLayout from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/TwoColumnQuizReviewLayout.vue'
import ResponseItem from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/ResponseItem.vue'

export default {
  components: {
    ResponseItem,
    TwoColumnQuizReviewLayout,
  },
  props: {
    dataAnswer: {
      type: Object,
      default: () => {
      },
    },
  },
  computed: {
    answers() {
      const allOptions = this.dataAnswer?.slideDetails?.SlideOptions

      if (!allOptions) {
        return []
      }
      return allOptions.filter((option) => option.correct)
    },
    responses() {
      const vottedAnswerIds = this.dataAnswer?.Answer?.vote
      if (!vottedAnswerIds || vottedAnswerIds.length === 0) {
        return []
      }
      return this.answers.filter((answer) => vottedAnswerIds.includes(answer.id))
    },
  },
}
</script>
